export const ListToPipeSeperator = (list: string[]): string => {
  return list.join('|');
};
